import {
  all,
  call,
  takeLatest,
} from 'redux-saga/effects';

import {
  getUsers,
  getUser,
  createUser,
  editUser,
  deleteUser,
  bulkDeleteUsers,
  blockUser,
  unblockUser,
  bulkBlockUsers,
  bulkUnblockUsers,
  convertFake,
} from 'api/users';
import { USERS_ACTION_TYPES } from 'store/actions/users.actions';
import { getRangeDate } from 'utils/dateHelpers';

function* loadUsersFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { registeredAt, lastOnlineAt, status, fake, 'profile.gender': gender, ...rest } = payload;
    let filters = rest;
    if (gender) {
      filters.gender = gender;
    }
    switch (status) {
      case 'active':
        filters.is_banned = '0';
        filters.is_deactivated = '0';
        break;
      case 'blocked':
        filters.is_banned = '1';
        filters.is_deactivated = '0';
        break;
      case 'deactivated':
        filters.is_deactivated = '1';
        break;
    }
    if (lastOnlineAt) {
      filters = {
        ...filters,
        ...getRangeDate('lastOnlineAt', lastOnlineAt),
      }
    }
    if (registeredAt) {
      filters = {
        ...filters,
        ...getRangeDate('registeredAt', registeredAt),
      }
    }
    if (fake !== undefined) {
      filters.is_fake = fake;
    }
    const { data } = yield call(getUsers, filters);
    resolve({
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadUserFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getUser, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

const _formatUser = (user) => {
  const { profile: { avatar }, ...data } = user;
  data.profile = {
    ...user.profile,
    avatar: avatar?.[0]?.['@id'] || null,
  }
  return data;
}

function* createUserFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(createUser, _formatUser(payload));
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editUserFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, data } = payload;
    const { data: response } = yield call(editUser, id, _formatUser(data));
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteUserFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    if (Array.isArray(payload)) {
      const { data: response } = yield call(bulkDeleteUsers, payload);
      resolve(response);
    } else {
      const { data: response } = yield call(deleteUser, payload);
      resolve(response);
    }
  } catch (e) {
    reject(e.response.data);
  }
}

function* blockUserFlow(action) {
  const { payload, resolve, reject } = action;
  const { id, data } = payload;
  try {
    if (Array.isArray(id)) {
      const { data: response } = yield call(bulkBlockUsers, id, data);
      resolve(response);
    } else {
      const { data: response } = yield call(blockUser, id, data);
      resolve(response);
    }
  } catch (e) {
    reject(e.response.data);
  }
}

function* unblockUserFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    if (Array.isArray(payload)) {
      const { data: response } = yield call(bulkUnblockUsers, payload);
      resolve(response);
    } else {
      const { data: response } = yield call(unblockUser, payload);
      resolve(response);
    }
  } catch (e) {
    reject(e.response.data);
  }
}

function* convertFakeFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(convertFake, payload.id, payload.data);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

export default function* () {
  yield all([
    takeLatest(USERS_ACTION_TYPES.LOAD_USERS, loadUsersFlow),
    takeLatest(USERS_ACTION_TYPES.LOAD_USER, loadUserFlow),
    takeLatest(USERS_ACTION_TYPES.CREATE_USER, createUserFlow),
    takeLatest(USERS_ACTION_TYPES.EDIT_USER, editUserFlow),
    takeLatest(USERS_ACTION_TYPES.DELETE_USER, deleteUserFlow),
    takeLatest(USERS_ACTION_TYPES.BLOCK_USER, blockUserFlow),
    takeLatest(USERS_ACTION_TYPES.UNBLOCK_USER, unblockUserFlow),
    takeLatest(USERS_ACTION_TYPES.CONVERT_FAKE, convertFakeFlow),
  ]);
}
